import { gql } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';
import type { QueryFunctionContext } from '@tanstack/react-query';

export const getQueryKey = (
  token: string,
  companyId: string
): ['company-share-status', string, string] => {
  return ['company-share-status', token, companyId];
};

export const validateCompanyShareToken = async ({
  queryKey: [_key, token, companyId],
}: QueryFunctionContext<[string, string, string]>) => {
  const {
    validateCompanyShareToken: { logo, valid, userBusinessLogo },
    errors,
  } = await gqlClient.request(
    gql(`
      query validateCompanyShareToken($token: String!, $companyId: String!) {
        validateCompanyShareToken(token: $token) {
          expires
          logo
          valid: isValidFor(companyId: $companyId)
          userBusinessLogo {
            logoUrl
          }
        }
      }
    `),
    {
      token,
      companyId,
    }
  );
  if (errors?.length) {
    const [firstError] = errors;
    console.error(firstError.message);
    return {
      isValidShareToken: false,
    };
  }
  console.info('responding wtf bro');
  return { isValidShareToken: valid, logo: userBusinessLogo?.logoUrl ?? logo };
};

export const createCompanyShareToken = async ({
  companyId,
}: {
  companyId: string;
}) => {
  try {
    const response = await gqlClient.request(
      gql(`
        mutation createCompanyShareToken($companyId: ID!) {
          createCompanyShareToken(companyId: $companyId)
        }
      `),
      {
        companyId,
      }
    );
    const { createCompanyShareToken, errors } = response;
    if (errors && errors.length > 0) {
      throw new Error(errors[0].message);
    }
    return createCompanyShareToken;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
